'use strict';

const h = require('phy');

const shouldFade = ({ fadeNode }) => (fadeNode ? '.fade-out' : '');

const setProps = bhw => {
  const props = { role: 'alert' };
  if (bhw) {
    Object.assign(props, {
      'data-bhw': bhw,
      'data-bh-viewport': 'respect',
    });
  }
  return props;
};

const notificationComponent = props => {
  const {
    bhw,
    messageText,
    notificationKlass,
    touchRequest,
    signInUrl,
    signInText,
    showGuestCTAWidget,
  } = props;
  return h(
    touchRequest
      ? `.notification${notificationKlass}${shouldFade(props)}`
      : `${notificationKlass}`,
    setProps(bhw),
    h('.text-message', messageText),
    showGuestCTAWidget()
      ? h(
          'a.sign-in-link',
          {
            'data-bhw': 'ClickToApplyPromoCodeSignIn',
            'data-bh-viewport': 'respect',
            href: signInUrl,
          },
          signInText
        )
      : null
  );
};

module.exports = notificationComponent;
